import { Component } from '@angular/core';
import { UtilService } from 'src/app/shared/services';
import { NavigationEnd, Router } from '@angular/router';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-hf-footer',
  standalone: true,
  imports: [
    CommonModule
  ],
  templateUrl: './hf-footer.component.html',
  styleUrls: ['./hf-footer.component.scss']
})
export class HfFooterComponent {
  currentYear = new Date().getFullYear();
  info = {
    desc: 'Insurance products are offered and serviced by Medibuddy Private Limited',
    links: {
      topText: `© ${this.currentYear} Ketto Online Ventures Pvt Ltd. All Rights Reserved.`,
      socialLinks: [
        { id: 1, icon: 'icon-linkedin', link: 'https://www.linkedin.com/company/ketto-online-ventures-private-limited' },
        { id: 2, icon: 'icon-instagram1', link: 'https://www.instagram.com/kettoindia/' },
        { id: 3, icon: 'icon-twitter', link: 'https://twitter.com/ketto' },
        { id: 4, icon: 'icon-facebook', link: 'https://www.facebook.com/profile.php?id=100064806753864' },
        { id: 5, icon: 'icon-youtube1', link: 'https://www.youtube.com/@Kettoindia' },
      ]
    }
  }
  hideFooter = false;

  constructor(
    public util: UtilService,
    private router: Router
  ) {
    this.subs.push(this.router.events
      .subscribe((event) => {
        this.url = this.getRouterUrlWithoutParams();
        if (event instanceof NavigationEnd && this.util.isMobile()) {
          if (this.url === '/healthfirst/calculator' 
            || this.url === '/healthfirst/price-breakup' 
            || this.url === '/healthfirst/risk-meter' 
            || this.url === '/healthfirst/thankyou') {
            this.hideFooter = true;
          }
        }
      })
    );
  }
  url;
  subs = [];

  ngOnInit() {
    this.url = this.getRouterUrlWithoutParams();
  }

  getRouterUrlWithoutParams() {
    return this.router.url.split('?')[0];
  }

  ngOnDestroy() {
    this.subs.forEach(sub => sub.unsubscribe());
  }
}
